// extracted by mini-css-extract-plugin
export default {"container":"category_container__8eSbl","icon":"category_icon__EfxW3"};